import React from 'react';

export default function RadarPage() {
  return (
    <div>
      Qualidade - Radar (placeholder).
    </div>
  );
}

